import { DynamicFormContext, DynamicFormAttachmentSlot } from "@bevco/Widgets/DynamicForm/DynamicForm";
import React from "react";

/**
 * Registers upload file/name key pairs so submit can send files in `attachments`
 * instead of Lead field values.
 */
export const useRegisterDynamicFormAttachments = (
    widgetId: string,
    slots: Array<DynamicFormAttachmentSlot | null | undefined>,
    enabled = true,
) => {
    const { registerAttachmentSlots, unregisterAttachmentSlots } = React.useContext(DynamicFormContext);
    const normalizedSlots = slots
        .filter((slot): slot is DynamicFormAttachmentSlot => !!slot?.fileKey && !!slot?.nameKey)
        .map(slot => ({
            fileKey: slot.fileKey.trim(),
            nameKey: slot.nameKey.trim(),
        }));

    const slotsSignature = normalizedSlots.map(slot => `${slot.fileKey}|${slot.nameKey}`).join(",");

    React.useEffect(() => {
        if (!enabled || !widgetId || !registerAttachmentSlots) {
            return;
        }

        registerAttachmentSlots(widgetId, normalizedSlots);
        return () => {
            unregisterAttachmentSlots?.(widgetId);
        };
    }, [enabled, widgetId, slotsSignature, registerAttachmentSlots, unregisterAttachmentSlots]);
};
